import { createSlice } from '@reduxjs/toolkit';
import type { AnalyticsState } from './analytics-interface';
import { setAnalyticsDateRangeFun, setSelectedOrganizationNamesFun } from './analytics-utils';

export const analyticsStateSliceName = 'analyticsStateSlice';

export const analyticsStateInitialValue: AnalyticsState = {
  selectedOrganizationNames: [],
  dateRangeStart: null,
  dateRangeEnd: null,
};

export const analyticsStateSlice = createSlice({
  name: analyticsStateSliceName,
  initialState: analyticsStateInitialValue,
  reducers: {
    setSelectedOrganizationNames: setSelectedOrganizationNamesFun,
    setAnalyticsDateRange: setAnalyticsDateRangeFun,
  },
});

export const { setSelectedOrganizationNames, setAnalyticsDateRange } = analyticsStateSlice.actions;
export const analyticsStateSliceReducerKey = 'analytics';
export default analyticsStateSlice.reducer;
